import React from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <Container
      maxWidth="sm"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        textAlign: 'center',
      }}
    >
      <Typography
        variant="h1"
        component="div"
        gutterBottom
        sx={{ fontSize: '6rem', fontWeight: 'bold', color: 'primary.main' }}
      >
        404
      </Typography>
      <Typography
        variant="h6"
        sx={{ marginBottom: 2, color: 'text.secondary' }}
      >
        The page you're looking for doesn't exist.
      </Typography>
      <Button
        variant="contained"
        component={Link}
        to="/"
        sx={{ mt: 3 }}
      >
        Go Back Home
      </Button>
    </Container>
  );
};

export default NotFoundPage;